/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CancelCaseResult {
  Error = 0,
  Success = 1,
  CaseNotFound = 2,
  InvalidStatus = 3,
  AlreadyCancelled = 4,
}
